import { get, post, put } from './';
import { post as topicPost, topic, topicCategory } from './schema';

export const getTopicCategories = placeId =>
   get(`/v1/places/${placeId}/forum/topic_categories`, { schema: [topicCategory] });

export const getTopic = topicId => get(`/v1/forum/topics/${topicId}`, { schema: topic });
export const getTopicPosts = topicId => get(`/v1/forum/topics/${topicId}/posts`, { schema: [topicPost] });
export const createTopic = ({ placeId, payload }) =>
   post(`/v1/places/${placeId}/forum/topics`, payload, { schema: topic });
export const archiveTopic = ({ topicId }) => post(`/v1/forum/topics/${topicId}/archive`, null, { schema: topic });
export const unarchiveTopic = ({ topicId }) => post(`/v1/forum/topics/${topicId}/unarchive`, null, { schema: topic });
export const createPost = ({ topicId, payload }) =>
   post(`/v1/forum/topics/${topicId}/posts`, payload, { schema: topicPost });
export const markTopicAsRead = topicId => put(`/v1/forum/topics/${topicId}/mark_as_read`, null, { schema: topic });
export const updateTopic = ({ topicId, payload }) => put(`/v1/forum/topics/${topicId}`, payload, { schema: topic });
export const updatePost = ({ postId, payload }) => put(`/v1/forum/posts/${postId}`, payload, { schema: topicPost });
